/* @flow */
import CAProvinces from 'lib/geo/CAProvince';
import USStates from 'lib/geo/USState';

export type ValidOrgCountry = 'US' | 'CA';

export const regionsForCountry = {
  US: { label: 'State', regions: USStates },
  CA: { label: 'Province', regions: CAProvinces },
};

export default [{ value: 'US', label: 'United States' }, { value: 'CA', label: 'Canada' }];
